import { render, staticRenderFns } from "./comp_Breadcrumbs.vue?vue&type=template&id=c7c00df8&scoped=true&"
import script from "./comp_Breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./comp_Breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./comp_Breadcrumbs.vue?vue&type=style&index=0&id=c7c00df8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c00df8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBreadcrumbs,VIcon})
